import React, { useState } from 'react';

const Copy = (props: { path: any; isOpen: boolean }) => {
  const [isCopied, setIsCopied] = useState(props.isOpen);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(props.path);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 1500);
  };

  return (
    <div className="relative mx-1" data-testid="copy-wrapper">
      <button data-testid="clickCopy" onClick={() => handleCopyToClipboard()}>
        <i className="fa-solid fa-clipboard text-[#0369a1]"></i>
      </button>

      {isCopied && (
        <span
          data-testid={'copied'}
          className="text-green-700 w-max absolute text-base left-[-28px] bottom-[20px]"
        >
          Copied!
        </span>
      )}
    </div>
  );
};

export default Copy;
